/**
 * @generated SignedSource<<b8b4c981aa060d84db4af2daa1a3bfdf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListSectionHeaderRoutine_Routine$data = {
  readonly ownerTeam: {
    readonly " $fragmentSpreads": FragmentRefs<"TeamIconCircleComponent_Team">;
  } | null;
  readonly title: string;
  readonly " $fragmentType": "ListSectionHeaderRoutine_Routine";
};
export type ListSectionHeaderRoutine_Routine$key = {
  readonly " $data"?: ListSectionHeaderRoutine_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListSectionHeaderRoutine_Routine">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListSectionHeaderRoutine_Routine",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "ownerTeam",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamIconCircleComponent_Team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};

(node as any).hash = "06d035681ed310c8eb2e448fc27ad315";

export default node;
